export const colors = {
  P1: '#0C3932',
  p2: '#00303C',
  vibrantgreen: '#0CAE5C',
  palegreen: '#77FF9E', // Added missing # for hex value
  paleblue: '#77E4FF',
  darkblue: '#079ABF',
  text: '#020617',
  border: '#E2E8F0',
  secondary: '#475569',
  primary: '#1F2937',
  danger: '#A63418',
  'button-primary': '#625CCB',
  'neutral-black': '#213147',
  'text-brand': '#625CCB',
  'success-light': '#EEF7F2',
  'text-success': '#177A48',
  'bg-warning': '#F18F01',
  warning: '#F18F01',
  'bg-danger': '#C73E1D',
  'bg-danger-light': '#FAEDEB',
  'bg-brand-disabled': '#B0ADE5',
  'bg-light': '#F8FAFC',
  background: '#F8F9FB',
  "processing-bg":"#DDF1FF",
  "completed-bg":"#F1FFF8",
  "failed-bg":"#FAEDEB",


  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    950: '#030712',
  },
  error: {
    50: '#FFF1F2',
    100: '#FFE4E6',
    200: '#FECDD3',
    300: '#FDA4AF',
    400: '#FB7185',
    500: '#F43F5E',
    600: '#E11D48',
    700: '#BE123C',
    800: '#9F1239',
    900: '#881337',
    950: '#4C0519',
  },
  success: {
    50: '#F0FDF4',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#86EFAC',
    400: '#4ADE80',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
    900: '#14532D',
    950: '#052E16',
  },

  stone: {
    100: '#F5F5F4',
  },
  neutral: {
    600: '#B8C0CE',
  },
  purple: {
    500: '#625CCB',
  },
  vibrant: {
    green: '#0CAE5C',
  },
  p1: '#0C3932',
  blue: {
    700: '#3A7BAA',
  },
  green: {
    600: '#16A34A',
    50: '#F0FDF4',
    pale: '#77FF9E',
  },
  red: {
    600: '#DC2626',
  },
};

export const screens = {
  xs: '30em',
  sm: '48em',
  md: '64em',
  lg: '74em',
  xl: '90em',
  xxl: '130em', // Extra extra large screens (update if needed)
};

export const fontSize = {
  xs: '0.5rem',
  sm: '0.75rem',
  base: '0.875rem',
  md: '1rem',
  lg: '1.25rem',
  xl: '1.5rem',
};
